import { Component, ElementRef, Input, OnInit, ViewChild, Output, EventEmitter, OnDestroy,} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subject, Subscription } from 'rxjs';
import { ResponseType } from 'src/app/enums/server-response-status';
import { ApiService } from 'src/app/services/api.service';
import { EventService } from 'src/app/services/event.service';
import { StorageService } from 'src/app/services/storage.service';
import { takeUntil } from 'rxjs/operators';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { OffersParamsKey } from 'src/app/helpers/paramsCaptures';
import endpoints from 'src/app/helpers/endpoints';
import { MapsService } from 'src/app/services/maps.service';
import { SidenavService } from 'src/app/layout/sidenav/sidenav.service';
import { Location } from '@angular/common';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { environment } from 'src/environments/environment';
import { CustomerDashboardService } from '../../../services/customer-dashboard.service';
import { CommonService } from 'src/app/services/common.service';
import { MatSelectChange } from '@angular/material/select';


@Component({
  selector: 'fury-lead-generate',
  templateUrl: './lead-generate.component.html',
  styleUrls: ['./lead-generate.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation]
})
export class LeadGenerateComponent implements OnInit, OnDestroy {

  leadForm!: FormGroup;
  @ViewChild('benotifyCoverdformaddress', { static: true }) public benotifyCoverdformaddress!: ElementRef;
  subs: Subscription[] = [];
  responseDetails!: any;
  @Input() beNotifyFormText!: string;
  @Input() utmSource!: OffersParamsKey;
  @Output() stepChange = new EventEmitter<any>();
  @Output() serverMessage = new EventEmitter<any>();
  message: string = '';
  ResponseType = ResponseType;
  showForm: boolean = true;
  deviceInformation!:any;
  @Input() isRightSide: any;
  showZipcodeField:boolean = false;
  sessionId !:string;
  ngUnsubscribe =  new Subject<void>();
  isCovered!: boolean;
  propertySize: any[] = [];
  propertyType: any[] = [];
  allStates : any[] = [];
  userId = '';
  assetsUrl = environment.assetsUrl + 'images/';
  leadInputEnum = {
    createLead: 1,
    selectLead: 2,
  }
  selectedLeadOpetion = this.leadInputEnum.createLead;
  searchType = "contains";
  pageIndex = 0;
  pageSize = 30;
  totalCount = 0;

  displayedColumns: string[] = [
    "vanillaSoftStatus",
    "consumer",
    "resultCode",
    "attempts",
    "addedOn",
    "lastAgentName",
    "submission",
    "firstName",
    "lastName",
    "streetAddress",
    "city",
    "state",
    "zip",
    "mobileNumber",
    "emailAddress",
    "notes",
    "leadAction",
  ];

  dataSource = [];
  selectConfig = { disableOptionCentering: true, panelClass: "custom-class" };
  propertySizeWithPropertyType: any[] = [];
  
  constructor (
    public storage: StorageService,
    public apiService: ApiService,
    public event: EventService,
    private router: Router,
    private mapService: MapsService,
    private activateRoute: ActivatedRoute,
    private sideNaveService: SidenavService,
    public location: Location,
    private customerDashboardService: CustomerDashboardService,
    private commonService: CommonService,
  ) { }

  ngOnInit(): void {
    this.userId = this.activateRoute.snapshot.params["id"];
    setTimeout(()=>{
      this.sideNaveService.close();
    }, 0)
    this.formInIt();
    this.getUserData();
    this.fetchLeadsDetails();
    this.getAllstate();
    this.getPropertyType();
    this.event.UserDeviceType.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res:any)=>{
      this.deviceInformation = res;
    });
    this.leadForm.get('phone')?.valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res:any)=>{
      if(res.startsWith('800') || res.startsWith('888') || res.startsWith('877') || res.startsWith('866') || res.startsWith('855') || res.startsWith('844') || res.startsWith('833')) {
        this.leadForm.controls['phone'].setErrors({ notValid: true });
      }   
    });
    this.sessionId = this.storage.getSessionId();
    this.getPropertySizeWithPropertyType();
  }
  zip(e:any){
    if(this.leadForm?.value?.zip?.length){
      this.checkZipCode();
    }
  }


  ngAfterViewInit() {
    if (this.benotifyCoverdformaddress) {
      this.mapService.autoFillLocation(this.benotifyCoverdformaddress, 'benotifyCoverdformaddress');
    }
    this.mapService.getaddressEvent
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: any) => {
        if (res && typeof (res) === 'object' && res.root === 'benotifyCoverdformaddress') {
          this.leadForm.patchValue(res);
          this.leadForm.get('zip').setValue(res.zipcode);
         if (res?.state) this.checkedCoveredOrNotCovered(res.state);
          if(!res?.zipcode){
            this.showZipcodeField = true;
          } else {
            this.showZipcodeField = false;
          }
        }
      });
  }

  formInIt() {
    this.leadForm = new FormGroup({
      first_name: new FormControl('', [Validators.required, Validators.minLength(2)]),
      last_name: new FormControl('', [Validators.required, Validators.minLength(2)]),
      phone: new FormControl('', [Validators.required, Validators.pattern(/^[2-9][0-8]\d{1}[2-9]\d{2}\d{4}$/)]),
      email: new FormControl('', [Validators.required, Validators.pattern(/^[\w.-]+@[\w.-]+\.\w{2,3}$/)]),
      address: new FormControl('', [Validators.required]),
      unitNumber: new FormControl(''),
      city: new FormControl('', [Validators.required]),
      state: new FormControl('', [Validators.required]),
      zip: new FormControl('', [Validators.required]),
      planSizeId: new FormControl('', [Validators.required]),
      planTypeId : new FormControl('', [Validators.required]),
      
    })
  }

  changeEmailAndSet() {    
    this.leadForm.controls['email'].patchValue(this.leadForm.value.email.replace(/\s+/g, ''))
   }

  submitQuote() {
    if(!this.storage.getIp()?.query){
      this.apiService.alert('Please change browser privacy setting to request a price quote', 'error');
      return;
    }
    if(!this.leadForm.value?.zip && this.leadForm.value?.address){
      this.showZipcodeField = true;
      return;
    }
    if (this.leadForm.valid) {
     this.leadForm.disable();
      let dataSet = Object.assign({},
        this.leadForm.value,
        {
          address: this.benotifyCoverdformaddress.nativeElement.value.split(',')[0],
          apikey: (this.utmSource && this.utmSource['apiKey']) ? this.utmSource['apiKey'] : 'pz3vp97e',
          email: this.leadForm.value.email.toLowerCase(),
          phone: this.leadForm.value.phone,
          ip: this.storage.getIp()?.query,
          external_id: this.createUniqueId(),
          address2: '',
          cpl: (this.utmSource && this.utmSource['cpl']) ? this.utmSource['cpl'] : null,
          user_id: this.userId
        }
      );
      let index = this.checkCoveredStates(this.leadForm.value.state);
      const url = index ? 'https://portal.elitehw.com/lead-api/lead-api.php' : 'https://portal.elitehw.com/lead-api/lead-api-waitlist.php';
      this.checkVpnStatus(dataSet, url, index);
    } else {
      this.leadForm.markAllAsTouched();
    }
  }
  checkVpnStatus(data: any, apiUrl: string, checkStateStatus: boolean) {
    return new Promise((resolve, reject) => {
      this.leadForm.controls['email'].setErrors({ loading: true });
      if(this.storage.getIp() === null || this.storage.getIp() === undefined) this.apiService.getlocation();
      if(this.storage.getIp()) { data['location'] = this.storage.getIp().city +'-'+this.storage.getIp().region}
      const x = sessionStorage.getItem('queryParams')?.split('-*-') || [];
      x.forEach((key: any) => {
        if (sessionStorage.getItem(key)) data[`${key}`] = sessionStorage.getItem(key);
      })
      
      data['device'] = (`${this.deviceInformation?.device.toLowerCase() === "unknown" ? '' : this.deviceInformation?.device + '-'}${this.deviceInformation?.deviceType.toLowerCase() === 'unknown' ? '' : this.deviceInformation?.deviceType}`).replace(/\-$/,'');

      data['device_id'] = (`${this.deviceInformation?.browser.toLowerCase() === 'unknown' ? '' : this.deviceInformation?.browser + '-'}${this.deviceInformation?.browser_version.toLowerCase() === 'unknown' ? '' : this.deviceInformation?.browser_version + '-'}${this.deviceInformation?.os.toLowerCase() === 'unknown' ? '' : this.deviceInformation?.os }${this.deviceInformation?.os_version.toLowerCase() === 'unknown' ? '' : '-' + this.deviceInformation?.os_version}`).replace(/\-$/,'');

      data['os_info'] = this.deviceInformation?.os_version === 'unknown' ? this.deviceInformation?.os : this.deviceInformation?.os_version;
      data['browser_info'] = this.deviceInformation?.browser;
      data['session_id'] = this.sessionId;

      if (sessionStorage.getItem('referrer')) data['referral_website'] = sessionStorage.getItem('referrer')
      data['internal_url'] = window.location.href;

      this.apiService.postCustom(endpoints.customerDashboard.leadGenerate, data).pipe(takeUntil(this.ngUnsubscribe)).subscribe({
        next: (res: HttpResponse<any>) => {
          if (res.status === 200) {
            if(checkStateStatus){
              this.event.checkoutAddress.next({
                firstName: this.leadForm.value?.first_name,
                lastName: this.leadForm.value?.last_name,
                address: this.leadForm?.value.address,
                city: this.leadForm.value?.city,
                state: this.leadForm.value?.state,
                zip: this.leadForm.value?.zip,
                apikey: (this.utmSource && this.utmSource['apiKey']) ? this.utmSource['apiKey'] : 'pz3vp97e',
                email: this.leadForm.value.email.toLowerCase(),
                phone: this.leadForm.value.phone,
                ip: this.storage.getIp()?.query,
                external_id: this.createUniqueId(),
                cpl: (this.utmSource && this.utmSource['cpl']) ? this.utmSource['cpl'] : null,
                planTypeId: this.leadForm.value?.planTypeId,
                planSizeId: this.leadForm.value?.planSizeId,
                leadId: res.body?.leadId,
                unitNumber: this.leadForm.value?.unitNumber,
                leadSource: res.body?.leadSource,
                resultCode: res.body?.resultCode
              });
   
              this.router.navigateByUrl(`customer-dashboard/${this.userId}/checkout`); 
            } else {
              this.responseDetails = {
                city: this.leadForm.value.city,
                state: this.leadForm.value.state,
                status: ResponseType.Declined,
                leadId : res?.body?.leadId
              };
            }
            this.message = ResponseType.SUCCESS;
            this.showForm = false;
            this.formInIt();
            this.leadForm.markAsUntouched();
           
          }
          // this.event.setAddressEvent(false);
        },
        error: (err: any) => {
          if (err) {
            this.leadForm.enable();
            reject();
            if (err.status === 406) {
              this.serverMessage.emit({
                city: this.leadForm.value.city,
                state: this.leadForm.value.state,
                status: ResponseType.Declined,
                leadId : null
              });
              this.message = ResponseType.Declined;
              this.showForm = false;
            } else {
              if (err.error.validationApiResponse.emailAddress.result === "invalid" || err.error.validationApiResponse.emailAddress.result === "unknown") {
                this.leadForm.controls['email'].setErrors({ notValidEmail: true });
                this.apiService.alert('Email Address Must Be Valid', 'error');
              } else if (!['connected', 'connected-75'].includes(err.error.validationApiResponse.phoneNumber.carrierInformation.status)) {
                this.leadForm.controls['phone'].setErrors({ notValid: true });
                this.leadForm.controls['email'].clearValidators();
                this.leadForm.controls['email'].updateValueAndValidity();
                this.apiService.alert('Phone Number Must Be Valid', 'error');
              } else if(err.error?.vpnApiResponse?.security?.relay && !err.error?.vpnApiResponse?.security?.vpn && !err.error?.vpnApiResponse?.security?.proxy){
                if(checkStateStatus){
                  this.responseDetails = {
                    city: this.leadForm.value.city,
                    state: this.leadForm.value.state,
                    status: ResponseType.SUCCESS,
                    leadId : null
                  };
                } else {
                  this.responseDetails = {
                    city: this.leadForm.value.city,
                    state: this.leadForm.value.state,
                    status: ResponseType.Declined,
                    leadId : null
                  };
                }
              } else if(['connected', 'connected-75'].includes(err.error.validationApiResponse.phoneNumber.carrierInformation.status) && err.error.validationApiResponse.emailAddress.result !== "invalid") {
                this.apiService.alert(err.error.message, 'error');
                this.leadForm.controls['email'].clearValidators();
                this.leadForm.controls['email'].updateValueAndValidity();
              }
            }

          }
          this.leadForm.markAllAsTouched();
        }
      });
    })
  }

  messageAfterApiCall() {
    setTimeout(() => {
      this.responseDetails = undefined;
    }, 90000);
  }

  checkZipCode(){
    this.apiService
    .getCityState(this.leadForm.controls['zip'])
    .then((data) => {
      if (data) {
        this.leadForm.patchValue(data);
        if(data?.state) this.checkedCoveredOrNotCovered(data.state);
      } else {
        this.leadForm.controls['zip'].setErrors({ notValid: true });
      
      }
    });
  };
  checkedCoveredOrNotCovered(state: string){
    this.isCovered = this.checkCoveredStates(state);
    if(!this.isCovered) this.leadForm.get('address').setErrors({notValid: true});
    
   };

   getPropertyType(){
    this.apiService.get(endpoints.customerDashboard.getPropertyType).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: HttpResponse<any>)=>{
      this.propertyType = res.body?.planPropertyTypes.data;
    })
  };
  getAllstate(){
    this.apiService.get(endpoints.customerDashboard.getAllState).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: HttpResponse<any>)=>{
      if(res.body){
        this.allStates = res.body?.states.data;
        this.customerDashboardService.setStates(this.allStates || []);
      }
    },
  (err: HttpErrorResponse)=> {
    this.customerDashboardService.setStates([]);
  })
  }
  createUniqueId() {
    return '_' + Math.random().toString(36).substr(2, 9);
  };
  checkCoveredStates(state: string) {
    const x = this.allStates.find(sta => sta.title.toLowerCase() === state.toLowerCase());
    return (x && (x.type === 'covered'));
  }
  redirectToDashboard() {
    this.router.navigateByUrl(`customer-dashboard/${this.userId}`);
  }

  fetchLeadsDetails() {
    this.apiService
      .get(
        `${endpoints.customerDashboard.getLeads(this.userId)}?page=${
          this.pageIndex + 1
        }&searchType=${this.searchType}&size=${this.pageSize}&isCheckout=1`
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (res: any) => {
          this.dataSource = res.body.leads.data;
          this.totalCount = res.body?.leads?.total;
        },
        () => {
          this.dataSource = [];
          this.totalCount = 0;
        }
      );
  }
  pageSizeChange(event: any) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.fetchLeadsDetails();
  }
  getPropertySizeWithPropertyType() {
    this.customerDashboardService.gePropertySizeWithPropertyType.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: any[])=>{
      if(res) {
        this.propertySizeWithPropertyType = res;
      }
    });
  };
  propertyTypeChange(event: MatSelectChange){
    this.leadForm.get('planSizeId')?.setValue('');
    this.propertySize = this.commonService.findPropertySizeByPropertyTypeId(event.value, this.propertySizeWithPropertyType);
  }
  getUserData(){
    this.customerDashboardService.getUserInfo$.pipe(takeUntil(this.ngUnsubscribe)).subscribe({
      next: (res:any)=>{
        if(res){
          this.leadForm.patchValue({
            first_name: res?.firstName,
            last_name: res?.lastName,
            phone: res?.phoneNumber,
            email: res?.emailAddress,
          });
        }
      }
    })
  }
  ngOnDestroy(): void { 
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
